import { ref, computed, unref } from 'vue'
import _ from 'lodash'
import { crearStorage } from './localforage'

import { DefinirRosetta, idiomasDisponibles } from '../../../../comun/rosetta'
import type { ColeccionDeTraducciones, IdiomasDisponibles } from '../../../../comun/rosetta'
export type { MicRosetta, ColeccionDeTraducciones, IdiomasDisponibles } from '../../../../comun/rosetta'
export { IdiomasDisponiblesZod } from '../../../../comun/idiomas'


const idiomaStore = crearStorage('idiomaStore')

const idiomaVisibleRef = ref<IdiomasDisponibles>('es')

const idiomaVisible = computed(() => unref(idiomaVisibleRef))

function identificarLenguajePreferidoPorNavegador(): IdiomasDisponibles | undefined {
  if (typeof navigator === 'undefined')
    return

  const navLangs = _.uniq(_.compact(navigator.languages))
  if (_.isEmpty(navLangs))
    return

  const encontrado = _.find(navLangs, (navlang) => {
    return _.some(idiomasDisponibles, idioma => navlang.startsWith(idioma))
  })
  if (!encontrado)
    return

  const idiomaDisponibleID = _.find(idiomasDisponibles, idiomaID => encontrado.startsWith(idiomaID))

  return idiomaDisponibleID
}

function esIdiomaValido(idioma: unknown): idioma is IdiomasDisponibles {
  return typeof idioma === 'string' && idiomasDisponibles.includes(idioma as IdiomasDisponibles)
}

function elegirIdiomaVisible(idiomaAVisibilizar: IdiomasDisponibles, guardar: boolean = false) {
  if (!esIdiomaValido(idiomaAVisibilizar)) {
    consolo.warn('[rosettas] Idioma rechazado, no es válido:', idiomaAVisibilizar)
    return
  }
  idiomaVisibleRef.value = idiomaAVisibilizar
  if (typeof document !== 'undefined') document.documentElement.setAttribute('lang', idiomaAVisibilizar);
  if (guardar) idiomaStore.setItem('idioma', idiomaAVisibilizar)
}

let inicializado = false
async function init() {
  if (inicializado)
    return
  inicializado = true
  const recordado = await idiomaStore.getItem<IdiomasDisponibles>('idioma')
  const preferidoPorNavegador = identificarLenguajePreferidoPorNavegador()
  const idiomaFinal = esIdiomaValido(recordado) ? recordado : preferidoPorNavegador ?? 'es'
  elegirIdiomaVisible(idiomaFinal, false)
}

init()

const RosettasATraductor = DefinirRosetta(idiomasDisponibles)

function crear<
    Traducciones extends ColeccionDeTraducciones,
    TraduccionID extends keyof Traducciones,
>(coleccionDeRosettas: Traducciones) {
  const traductor = RosettasATraductor(coleccionDeRosettas)
  return (traduccionID: TraduccionID) => traductor(traduccionID, unref(idiomaVisible))
}

// ==========
// API Unificada
// ==========

export const Rosettas = {
  elegirIdiomaVisible,
  crear,
  idiomaVisible,
  idiomasDisponibles,
  identificarLenguajePreferidoPorNavegador,
  init
}

export { idiomaVisible }
export default Rosettas
